"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalComponent = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames4 = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../ThemeProvider");

var _Portal = _interopRequireDefault(require("./Portal"));

var _activableRenderer = _interopRequireDefault(require("./activableRenderer"));

var _Button = _interopRequireDefault(require("../Button"));

var _Overlay = _interopRequireDefault(require("../Overlay"));

var _close = _interopRequireDefault(require("./assets/close.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          theme = _this$props.theme,
          defaultActionAppearance = _this$props.defaultActionAppearance,
          active = _this$props.active,
          closeModal = _this$props.closeModal,
          showCloseIcon = _this$props.showCloseIcon,
          className = _this$props.className,
          type = _this$props.type,
          title = _this$props.title,
          children = _this$props.children;
      var actionsMap = actions.map(function (action, idx) {
        var aClassName = (0, _classnames4["default"])(theme.button, _defineProperty({}, action.className, action.className));
        return _react["default"].createElement(_Button["default"], _extends({
          appearance: defaultActionAppearance,
          key: idx
        }, action, {
          className: aClassName
        }), action.label);
      });
      var dialogClassName = (0, _classnames4["default"])([theme.dialog, theme[type]], _defineProperty({}, theme.active, active), className);
      var closeButtomClassName = (0, _classnames4["default"])(theme.hideBackButton, _defineProperty({}, theme.backButton, closeModal));
      return _react["default"].createElement(_Portal["default"], {
        className: theme.wrapper
      }, _react["default"].createElement(_Overlay["default"], {
        active: active,
        className: theme.overlay,
        onClick: closeModal,
        onEscKeyDown: closeModal,
        theme: theme,
        themeNamespace: "overlay",
        showCloseIcon: showCloseIcon
      }), _react["default"].createElement("div", {
        "data-react-toolbox": "dialog",
        className: dialogClassName
      }, _react["default"].createElement("section", {
        role: "body",
        className: theme.body
      }, _react["default"].createElement("div", {
        className: theme.top
      }, title ? _react["default"].createElement("h6", {
        className: theme.title
      }, title) : null, _react["default"].createElement("a", {
        className: closeButtomClassName,
        onClick: closeModal
      }, _react["default"].createElement("img", {
        src: _close["default"],
        alt: "Close"
      }))), children), actionsMap.length ? _react["default"].createElement("nav", {
        role: "navigation",
        className: theme.navigation
      }, actionsMap) : null));
    }
  }]);

  return Modal;
}(_react.Component);

exports.ModalComponent = Modal;

_defineProperty(Modal, "propTypes", {
  actions: _propTypes["default"].array,
  defaultActionAppearance: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  onEscKeyDown: _propTypes["default"].func,
  onOverlayClick: _propTypes["default"].func,
  onOverlayMouseDown: _propTypes["default"].func,
  onOverlayMouseMove: _propTypes["default"].func,
  onOverlayMouseUp: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    active: _propTypes["default"].string,
    body: _propTypes["default"].string,
    button: _propTypes["default"].string,
    dialog: _propTypes["default"].string,
    navigation: _propTypes["default"].string,
    overlay: _propTypes["default"].string,
    title: _propTypes["default"].string,
    wrapper: _propTypes["default"].string
  }),
  title: _propTypes["default"].string,
  type: _propTypes["default"].string
});

_defineProperty(Modal, "defaultProps", {
  actions: [],
  defaultActionAppearance: 'primary',
  active: false,
  type: 'normal'
});

var _default = (0, _ThemeProvider.applyTheme)('Modal', (0, _activableRenderer["default"])()(Modal));

exports["default"] = _default;